import "./components/NavbarMenuDropdown.css";
import "./Header.css";

import { useUiKitComponents } from "@qws-org/ui-kit";
import { type FC, useState } from "react";
// в будущем данные будут приходить из cms
// eslint-disable-next-line boundaries/external
import { useTranslation } from "react-i18next";

import { HEADER_STATIC_TRANSLATIONS } from "~/features/header/translations";
import { Logo } from "~/icons";

import { HeaderAuthButtons } from "./components/HeaderAuthButtons";
import { LocaleSelect } from "./components/LocaleSelect";
import { NavbarItem } from "./components/NavbarItem";
import { NavbarItemMobile } from "./components/NavbarItemMobile";

export type NavigationItem = {
  id: ID;
  title: string;
  url: string;
  imageUrl?: string;
  imageAlternativeText: string | null;
};
export type NavigationType =
  | null
  | "dropdown"
  | "leaderboard"
  | "default"
  | "vip"
  | "jackvip"
  | "jackpass";
export type Navigation = {
  id: ID;
  navigationName: string;
  dropdownMenu: Array<{
    id: ID;
    title?: string;
    dropdownMenuPages: Array<NavigationItem>;
  }> | null;
  navigationUrl: string;
  type: NavigationType;

  dropdownPosition?: "left" | "right" | "center";
};

export type Option = {
  id: number;
  key: string;
  lang: LanguageCode;
  icon: string;
};

export type HeaderProps = {
  playNowLink: string;
  featureFlags: {
    isNavigationEnabled: boolean;
    isLanguageSelectorEnabled: boolean;
    isCreateButtonEnabled: boolean;
  };
  analytics: {
    clickHeaderMain: (targetUrl: string) => void;
    clickHeaderSub: (targetUrl: string) => void;
    loginHeader: () => void;
    createAccountHeader: () => void;
  };
};

export const Header: FC<HeaderProps> = ({
  playNowLink,
  featureFlags,
  analytics: {
    clickHeaderMain,
    clickHeaderSub,
    createAccountHeader,
    loginHeader,
  },
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  const [isBurgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const onBurgerMenuClick = (): void => setBurgerMenuOpen(!isBurgerMenuOpen);
  const [currentNavlink, setCurrentNavlink] = useState<string>("");

  const onNavlinkClick = (url: string, id: number): void => {
    clickHeaderMain(url);

    setCurrentNavlink(url + id);
  };

  const onRouteClick = (): void => setBurgerMenuOpen(false);

  const navigation: Array<Navigation> = [
    {
      id: 1,
      navigationName:
        HEADER_STATIC_TRANSLATIONS[language]["nav.link.promotions.text"],
      dropdownMenu: [
        {
          id: 1,
          dropdownMenuPages: [
            {
              id: 1,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.lucky-wheel.text"
                ],
              url: "/promotions/lucky-wheel",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "lucky-wheel",
            },
            {
              id: 2,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.welcome-winner.text"
                ],
              url: "/promotions/welcome-winner",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "welcome-winner",
            },
            {
              id: 3,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.tournament-guarantee.text"
                ],

              url: "/promotions/tournament-guarantee",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "tournament-guarantee",
            },
            {
              id: 4,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.spin-and-win.text"
                ],
              url: "/promotions/spin-and-win",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "spin-and-win",
            },
            {
              id: 5,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.cryptobonus.text"
                ],
              url: "/promotions/cryptobonus",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "cryptobonus",
            },
            {
              id: 6,
              title: HEADER_STATIC_TRANSLATIONS[language]["nav.link.series"],
              url: "/series",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "series",
            },
            {
              id: 7,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.promotions.submenu.link.flipout.text"
                ],
              url: "/promotions/flipout",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "flipout",
            },
          ],
        },
      ],
      navigationUrl: "/promotions",
      type: "dropdown",
    },
    {
      id: 6,
      navigationName: HEADER_STATIC_TRANSLATIONS[language]["nav.link.casino"],
      dropdownMenu: null,
      navigationUrl: "/casino/",
      type: "default",
    },
    {
      id: 7,
      navigationName: HEADER_STATIC_TRANSLATIONS[language]["nav.link.series"],
      dropdownMenu: null,
      navigationUrl: "/series/",
      type: "leaderboard",
    },

    {
      id: 8,
      navigationName:
        HEADER_STATIC_TRANSLATIONS[language]["nav.link.loading-trouble.text"],
      dropdownMenu: [
        {
          id: 1,
          dropdownMenuPages: [
            {
              id: 1,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.loading-trouble.submenu.link.black-screen.text"
                ],
              url: "/choose-device",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "choose-device-black-screen",
            },
            {
              id: 2,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.loading-trouble.submenu.link.failed-load-theme.text"
                ],
              url: "/choose-device",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "choose-device-failed-load-theme",
            },
            {
              id: 3,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.loading-trouble.submenu.link.infinite-reload.text"
                ],
              url: "/choose-device",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "choose-device-infinite-reload",
            },
            {
              id: 4,
              title:
                HEADER_STATIC_TRANSLATIONS[language][
                  "nav.link.loading-trouble.submenu.link.loading-screen.text"
                ],

              url: "/choose-device",
              imageUrl: "/promotion-menu.svg",
              imageAlternativeText: "choose-device-loading-screen",
            },
          ],
        },
      ],
      navigationUrl: "/",
      type: "dropdown",
    },
  ];

  const listOfLang: Array<Option> = [
    {
      id: 1,
      key: "EN",
      lang: "en",
      icon: "/en-flag.svg",
    },
    {
      id: 2,
      key: "ZH",
      lang: "zh",
      icon: "/ch-flag.svg",
    },
  ];

  const { Link } = useUiKitComponents();
  return (
    <header className="header" data-testid="header">
      <nav className="navbar">
        <Link
          onClick={onRouteClick}
          className="navbar-logo"
          href={"/"}
          data-testid="header-mainpage-link"
        >
          <Logo viewBox="0 0 189 49" />
        </Link>
        <div className={`navbar-left ${isBurgerMenuOpen && "opened"}`}>
          <>
            {featureFlags.isNavigationEnabled &&
              navigation?.map((item, idx) => (
                <div key={item.id} className="navbar-item-wrapper">
                  <NavbarItem
                    {...item}
                    currentNavlink={currentNavlink}
                    onNavlinkClick={onNavlinkClick}
                    clickHeaderSub={clickHeaderSub}
                    data-testid={`header-bottom-menu-item-${idx}`}
                  />
                  <NavbarItemMobile
                    {...item}
                    onRouteClick={onRouteClick}
                    clickHeaderMain={clickHeaderMain}
                    clickHeaderSub={clickHeaderSub}
                    dataTestId={`header-mobile-menu-item-${idx}`}
                  />
                </div>
              ))}
            {featureFlags.isLanguageSelectorEnabled && (
              <div className="navbar-item-wrapper">
                <div className="navbar-select-mobile">
                  <div className="navbar-item-mobile-wrapper locale-switch-wrapper">
                    <LocaleSelect languageList={listOfLang} locale={language} />
                  </div>
                </div>
              </div>
            )}
            {featureFlags.isCreateButtonEnabled && (
              <div className="navbar-item-wrapper">
                <div className="navbar-select-mobile">
                  <HeaderAuthButtons
                    featureFlags={featureFlags}
                    playNowLink={playNowLink}
                    burgerButton={true}
                    createAccountHeader={createAccountHeader}
                    loginHeader={loginHeader}
                  />
                </div>
              </div>
            )}
          </>
        </div>
        <div className="navbar-spacer" />
        {featureFlags.isLanguageSelectorEnabled && (
          <div className="navbar-item locale-switch locale-switch-desktop">
            <LocaleSelect languageList={listOfLang} locale={language} />
          </div>
        )}
        <div>
          <HeaderAuthButtons
            featureFlags={featureFlags}
            playNowLink={playNowLink}
            createAccountHeader={createAccountHeader}
            loginHeader={loginHeader}
          />
        </div>
        {featureFlags.isNavigationEnabled && (
          <div
            onClick={onBurgerMenuClick}
            className={`menu-button ${isBurgerMenuOpen && "opened"}`}
          >
            <span />
            <span />
            <span />
            <span />
          </div>
        )}
      </nav>
    </header>
  );
};
